import Flex from '@/shared/ui/Flex'

import styles from './StepsSimple.module.scss'

export type StepsSimpleProps = {
	title?: string
	items: { value: string }[]
	note?: string
}

export const StepsSimple = ({ title, items, note }: StepsSimpleProps): JSX.Element => (
	<div className={styles.stepsSimple}>
		<Flex column>
			{title && <h5 className={styles.title}>{title}</h5>}
			<ul className={styles.list}>
				{items.map((item, index) => (
					<li key={index} className={styles.item}>
						<span className={styles.itemNumber}>{index + 1}.</span>
						<span className={styles.itemText}>{item.value}</span>
					</li>
				))}
			</ul>
			{note && <p className={styles.note}>{note}</p>}
		</Flex>
	</div>
)
